import { sveltekitApiUrl } from "app/utils/urls";
import type { FolderWithPermissions } from "@outverse-video/outverse-api-client-lib";
import type { LayoutLoad } from "./$types";
import { handleApiError } from "$utils/errors";

/** Load folder data for sidepanel */
export const load: LayoutLoad = async ({ params, fetch }) => {
  const response = await fetch(`${sveltekitApiUrl()}/community/${params.community}/folders`).then(
    handleApiError
  );
  const json = (await response.json()) as FolderWithPermissions[];

  return {
    // flatten folders and perms
    folders: json.map((folder) => ({
      ...folder.folder,
      myPermissions: folder.myPermissions,
      folderItemType: "nested_folder" as const,
      docs: [],
    })),
    spaceType: "doc",
  };
};
